<template>
  <modal @close="$emit('close')">
    <template v-slot:title>
      Desconto de pontualidade
    </template>

    <template v-slot:body>
      <loading v-if="loading" full-parent />
      <select-field
        label="Referência"
        :options="daysRelativeToTypes"
        v-model="advancedPaymentDiscountRule.get('daysRelativeTo').value"
        :errors="advancedPaymentDiscountRule.get('daysRelativeTo').errors"
        @input="advancedPaymentDiscountRule.get('daysRelativeTo').validateField()"
      />
      <select-field
        label="Contagem"
        :options="daysKindTypes"
        v-model="advancedPaymentDiscountRule.get('daysKind').value"
        :errors="advancedPaymentDiscountRule.get('daysKind').errors"
        @input="advancedPaymentDiscountRule.get('daysKind').validateField()"
      />
      <input-field
        label="Dias de carência"
        placeholder="Número de dias"
        :mask="'##'"
        v-model="advancedPaymentDiscountRule.get('days').value"
        :errors="advancedPaymentDiscountRule.get('days').errors"
        @input="advancedPaymentDiscountRule.get('days').validateField()"
      />
      <select-field
        label="Tipo de desconto"
        :options="amountTypes"
        v-model="advancedPaymentDiscountRule.get('amountType').value"
        :errors="advancedPaymentDiscountRule.get('amountType').errors"
        @input="advancedPaymentDiscountRule.get('amountType').validateField()"
        @change="advancedPaymentDiscountRule.get('stackDiscounts').value = false"
      />
      <money-field
        v-if="advancedPaymentDiscountRule.get('amountType').value === 'absolute'"
        label="Valor"
        v-model="advancedPaymentDiscountRule.get('amount').value"
        :errors="advancedPaymentDiscountRule.get('amount').errors"
        @input="advancedPaymentDiscountRule.get('amount').validateField()"
      />
      <input-field
        v-if="advancedPaymentDiscountRule.get('amountType').value === 'percentage'"
        label="Porcentagem"
        input-group-text-append="%"
        :mask="'###'"
        v-model="advancedPaymentDiscountRule.get('percentage').value"
        :errors="advancedPaymentDiscountRule.get('percentage').errors"
        @input="advancedPaymentDiscountRule.get('percentage').validateField()"
      />
      <select-field
        label="Base de cálculo"
        :options="discountBasedOn"
        :disabled="advancedPaymentDiscountRule.get('amountType').value === 'absolute'"
        v-model="advancedPaymentDiscountRule.get('stackDiscounts').value"
        :errors="advancedPaymentDiscountRule.get('stackDiscounts').errors"
        @input="advancedPaymentDiscountRule.get('stackDiscounts').validateField()"
      />
      <checkbox-field
        label="Retroativo"
        value="retroactive"
        v-model="advancedPaymentDiscountRule.get('retroactive').value"
        :errors="advancedPaymentDiscountRule.get('retroactive').errors"
        @input="advancedPaymentDiscountRule.get('retroactive').validateField()"
      />
    </template>

    <template v-slot:footer>
      <button class="btn btn-primary" @click="create">
        Adicionar
      </button>
      <button class="btn btn-default" @click="$emit('close')">
        Fechar
      </button>
    </template>
  </modal>
</template>
<script>
import {
  CheckboxField, InputField, MoneyField, SelectField,
} from 'components/form';
import { FormGroup } from 'utils/form';
import Modal from 'components/Modal';
import Loading from 'components/Loading';
import EnumsService from 'services/EnumsService';

export default {
  components: {
    CheckboxField,
    InputField,
    Modal,
    MoneyField,
    SelectField,
    Loading,
  },
  data() {
    return {
      loading: false,
      daysRelativeToTypes: [],
      amountTypes: [],
      daysKindTypes: [],
      discountBasedOn: [
        { value: false, label: 'Valor cheio' },
        { value: true, label: 'Valor com desconto' },
      ],
      advancedPaymentDiscountRule: new FormGroup({
        daysRelativeTo: { required: true },
        daysKind: { required: true },
        days: { required: true, greaterThanOrEqualTo: 0 },
        amountType: { required: true },
        amount: {
          greaterThan: 0,
          requiredIfMatch: { amountType: { values: ['absolute'] } },
          ignoredOnGetRawValueIfMatch: [
            { amountType: { values: ['absolute'], condition: '!' } },
          ],
        },
        percentage: {
          greaterThan: 0,
          lowerThanOrEqualTo: 100,
          requiredIfMatch: { amountType: { values: ['percentage'] } },
          ignoredOnGetRawValueIfMatch: [
            { amountType: { values: ['percentage'], condition: '!' } },
          ],
        },
        stackDiscounts: { required: true },
        retroactive: { required: true, value: false },
        treatedAmountValue: {},
        translatedDaysRelativeTo: {},
        translatedDaysKind: {},
      }),
    };
  },
  mounted() {
    this.loading = true;

    Promise.all([
      this.getDaysRelativeToTypes(),
      this.getAmountTypes(),
      this.getDaysKindTypes(),
    ])
      .catch(() => {
        this.$router.push('/');
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    create() {
      if (this.advancedPaymentDiscountRule.validateForm()) {
        this.addTreatedAmountValue();
        this.addTranslatedTypes();
        this.$emit('advanced-payment-discount-created', this.advancedPaymentDiscountRule.getRawValue(true));
      }
    },
    addTreatedAmountValue() {
      if (this.advancedPaymentDiscountRule.getValue('amountType') === 'absolute') {
        this.advancedPaymentDiscountRule.addValues({
          treatedAmountValue: this.advancedPaymentDiscountRule.getValue('amount'),
        });
      } else {
        this.advancedPaymentDiscountRule.addValues({
          treatedAmountValue: parseFloat(
            this.advancedPaymentDiscountRule.getValue('percentage').replace(',', '.'),
          ) / 100.0,
        });
      }
    },
    addTranslatedTypes() {
      this.AddTranslatedDaysRelativeTo();
      this.AddTranslatedDaysKind();
    },
    AddTranslatedDaysRelativeTo() {
      this.advancedPaymentDiscountRule.addValues({
        translatedDaysRelativeTo: this.translatedTypes(
          this.daysRelativeToTypes,
          this.advancedPaymentDiscountRule.getValue('daysRelativeTo'),
        ),
      });
    },
    AddTranslatedDaysKind() {
      this.advancedPaymentDiscountRule.addValues({
        translatedDaysKind: this.translatedTypes(
          this.daysKindTypes,
          this.advancedPaymentDiscountRule.getValue('daysKind'),
        ),
      });
    },
    translatedTypes(types, value) {
      return types.find(el => el.value === value).label;
    },
    getDaysRelativeToTypes() {
      return EnumsService.getDaysRelativeToTypes()
        .then((daysRelativeToTypes) => {
          this.daysRelativeToTypes = daysRelativeToTypes;
        });
    },
    getAmountTypes() {
      return EnumsService.getAmountTypes()
        .then((amountTypes) => {
          this.amountTypes = amountTypes;
        });
    },
    getDaysKindTypes() {
      return EnumsService.getDaysKindTypes()
        .then((daysKindTypes) => {
          this.daysKindTypes = daysKindTypes;
        });
    },
  },
};
</script>
